import { Module, VuexModule, Mutation, MutationAction, getModule } from 'vuex-module-decorators';
import store from '@/store';
import { IQuickGuide, QuickGuide } from '../models/quickGuide/QuickGuide';
import { QuickGuideService } from '@/services';

export interface IQuickGuideStoreState {
    quickGuide: IQuickGuide;
}

@Module({ dynamic: true, store, name: 'quickGuideStore' })
class QuickGuideStoreModule extends VuexModule {
    public quickGuide: QuickGuide[] = [];

    /**
     * Fetch Quick Guide
     */
    @MutationAction({ mutate: ['quickGuide'] })
    public async FetchQuickGuide() {
        const response: QuickGuide[] = await QuickGuideService.FetchQuickGuide();
        return { quickGuide: response };
    }


    /**
     * Getter for quick guide
     */
    get GetQuickGuide() {
        return this.quickGuide;
    }
}

export const QuickGuideStore = getModule(QuickGuideStoreModule);
